import {ReCaptchaProvider, useReCaptcha} from "next-recaptcha-v3";
import React from "react";

type Props = {
	children: React.ReactNode
}

const ReCaptchaParent = ({children}: Props) =>
{
	return <ReCaptchaProvider>
		{children}
	</ReCaptchaProvider>
}

const useCaptcha = () =>
{
	if (process.env.NEXT_PUBLIC_NODE_ENV == 'development')
	{
		return {
			executeRecaptcha: async () =>
			{
				return 'test';
			}
		}
	}

	return useReCaptcha();
}

export {useCaptcha};

export default ReCaptchaParent;